import Notifications from '@kyvg/vue3-notification';

export function setupNotification(app) {
    app.use(Notifications);
};
